const USERS_KEY = 'real_estate_users';

export const getUsers = () => {
  const storedUsers = localStorage.getItem(USERS_KEY);
  return storedUsers ? JSON.parse(storedUsers) : [];
};

export const saveUser = (user) => {
  const users = getUsers();
  
  // Provjeri postoji li već korisnik s istim emailom
  const existingUser = users.find(u => u.email === user.email);
  if (existingUser) {
    return false; // Korisnik već postoji
  }
  
  users.push(user);
  localStorage.setItem(USERS_KEY, JSON.stringify(users));
  return true;
};

export const findUserByCredentials = (email, password) => {
  const users = getUsers();
  return users.find(user => user.email === email && user.password === password);
};

// Inicijalni admin korisnik
export const initializeUsers = () => {
  const users = getUsers();
  if (users.length === 0) {
    saveUser({
      id: 1,
      name: 'Admin',
      email: 'admin@nekretnine.com',
      password: 'admin123',
      role: 'admin'
    });
  }
};